"use client";

import { useEffect, useState } from "react";
import { getInsightsApi } from "../../utils/get-insights";

type MostPopularBookingDay = {
  day: string;
  total: number;
};

type UseDayUseBookingsProps = {
  startDate: string;
  endDate: string;
  companyId: number;
};

export function useDayUseBookings({
  startDate,
  endDate,
  companyId,
}: UseDayUseBookingsProps) {
  const [data, setData] = useState<MostPopularBookingDay>();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!startDate || !endDate || !companyId) {
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);

        const response = await getInsightsApi(
          "/most-popular-booking-day",
          startDate,
          endDate,
          12000,
          companyId.toString(),
        );

        setData(response);
      } catch (error) {
        console.error("Erro ao buscar dados de distribuição por dia:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate, companyId]);

  return { data, isLoading };
}
